import { render, staticRenderFns } from "./show.vue?vue&type=template&id=f0e68bdc&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0e68bdc')) {
      api.createRecord('f0e68bdc', component.options)
    } else {
      api.reload('f0e68bdc', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=f0e68bdc&", function () {
      api.rerender('f0e68bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/countries/show.vue"
export default component.exports